import React from "react"
import NavLeft from "../ui/NavLeft"
import { NavLink } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styled from "styled-components"
import astroIcon from "../features/astrosites/astro-icon.svg"
import astroLogo from "../icons/icon-astrosite-logo-half-darkback.svg"
import {
  faBinoculars,
  faCalendarPlus,
  faClockRotateLeft,
  faGlobe,
  faLifeRing,
  faList,
  faSatellite,
  faTasks,
  faUpload,
  faUserAstronaut,
} from "@fortawesome/free-solid-svg-icons"
import AdvancedModeToggle from "../features/settings/AdvancedModeToggle"
import Authed from "../features/iam/Authed"

const Link = styled(NavLink)`
  flex: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.5rem 0;
  border-left: 3px solid transparent;
  transition: all 0.3s ease-out;

  &:link {
    text-decoration: none;
  }

  &.active,
  &:hover {
    background-color: ${(props) => props.theme.colours.activebg};
    border-color: ${(props) => props.theme.colours.active};
    color: white;
  }
`
const Icon = styled.div`
  flex: none;
  width: 100%;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  @media (max-height: 850px) {
    font-size: 1rem;
    height: 1.5rem;
  }
`

const Text = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
`
const ImageIcon = styled(Icon)`
  background-position: center;
  background-size: 2rem;
  background-repeat: no-repeat;
`

const AstroIcon = styled(ImageIcon)`
  background-image: url(${astroIcon});
`

const LogoIcon = styled(Icon)`
  background-position: center;
  background-size: 3rem;
  background-repeat: no-repeat;
`

const AstroLogo = styled(LogoIcon)`
  background-image: url(${astroLogo});
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 2.5rem;
`

const Links = styled.div`
  flex: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  margin-top: auto;
  overflow-x: hidden;
  overflow-y: auto;
`

const Controls = styled.div`
  flex: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 1.5rem;
  margin-top: auto;
`

/** NavMain defines the top-level main navigation components,
 * typically directly nested within the <Layout>. */
const NavMain = () => {
  return (
    <NavLeft>
      <Links>
        <Link to="/dashboard">
          <Icon>
            <AstroLogo />
          </Icon>
          <Text>Dashboard</Text>
        </Link>
        <Link to="/observations">
          <Icon>
            <FontAwesomeIcon icon={faBinoculars} />
          </Icon>
          <Text>Observations</Text>
        </Link>
        <Link to="/priorities?sort_by=priority&sort_order=DESC">
          <Icon>
            <FontAwesomeIcon icon={faCalendarPlus} />
          </Icon>
          <Text>Priorities</Text>
        </Link>
        <Link to="/collections">
          <Icon>
            <FontAwesomeIcon icon={faList} />
          </Icon>
          <Text>Collections</Text>
        </Link>
        <Link to="/rsos">
          <Icon>
            <FontAwesomeIcon icon={faSatellite} />
          </Icon>
          <Text>RSOs</Text>
        </Link>
        <Link to="/astrosites">
          <Icon>
            <AstroIcon />
          </Icon>
          <Text>Astrosites</Text>
        </Link>
        <Link to="/passes?from=now&to=p48h">
          <Icon>
            <FontAwesomeIcon icon={faGlobe} />
          </Icon>
          <Text>Passes</Text>
        </Link>
        <Authed allowRoles={["admin"]}>
          <Link to="/data-submissions">
            <Icon>
              <FontAwesomeIcon icon={faUpload} />
            </Icon>
            <Text>Submissions</Text>
          </Link>
        </Authed>
        <Link to="/playlists">
          <Icon>
            <FontAwesomeIcon icon={faTasks} />
          </Icon>
          <Text>Schedules</Text>
        </Link>
        <Link to="/actions">
          <Icon>
            <FontAwesomeIcon icon={faClockRotateLeft} />
          </Icon>
          <Text>Audit log</Text>
        </Link>
      </Links>
      <Controls>
        <Link to="/support">
          <Icon>
            <FontAwesomeIcon icon={faLifeRing} />
          </Icon>
          <Text>Support</Text>
        </Link>
        <Link to="/profile">
          <Icon>
            <FontAwesomeIcon icon={faUserAstronaut} />
          </Icon>
          <Text>Profile</Text>
        </Link>
        <AdvancedModeToggle />
      </Controls>
    </NavLeft>
  )
}

export default NavMain
